import {CollectionClip} from "../types/collectionTypes";

export function findClosestAspectRatio(
    ratio: number,
    ratios: string[],
    epsilon: number = 0.001
): string | undefined {
    let closest: string | undefined = undefined
    let minDiff = Infinity

    for (const r of ratios) {
        const [w, h] = r.split(':').map(Number)
        const value = w / h
        const diff = Math.abs(value - ratio)

        if (diff < minDiff) {
            minDiff = diff
            closest = r
        }
    }

    return minDiff <= epsilon ? closest : undefined
}

export const extractPlatCuts = (cards: CollectionClip[]) => {
    const platCut: any[] = []
    for(const card of cards) {
        if(card.key_moments && card.key_moments[0]){
            const masterCut = card.key_moments[0]
            // trim_labels/trim_points must line up by chronological trim-point order
            // (start time), not by whatever order the cuts happen to occur in — e.g.
            // a GOAL/REPLAY/VAR triple authored in that order can have trim points
            // progressing GOAL, VAR, REPLAY, and sending the labels unsorted would
            // attach the wrong label to each trim point on save/render.
            const orderedCuts = [...masterCut.cuts].sort((a: any, b: any) => a.start - b.start)
            platCut.push(
                {
                    key_moment_id: card.id,
                    mode: "auto",
                    real_stream_reference: masterCut.stream_reference,
                    trim_labels: orderedCuts.map((cut: any) => cut.label),
                    trim_points: orderedCuts.map((cut: any) => [cut.start, cut.end])
                }
            )
        }
    }

    return platCut
}